import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchCategoriesAfterBooking } from "../../api/categoriesApi";
// import { fetchCategories } from "../../api/categories"; // Adjust path as necessary

// Async thunk for fetching categories
export const fetchCategoriesAfterBookingThunk = createAsyncThunk(
  "categories/fetchCategoriesAfterBooking",
  async ({ category_ids }, { rejectWithValue }) => {
    try {
      const response = await fetchCategoriesAfterBooking(category_ids);
      return response.data; // Assuming the response has a `data` property with categories
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Initial state
const initialState = {
  categories: [],
  loading: false,
  error: null,
};

// Slice
const categoriesAfterBookingSlice = createSlice({
  name: "categoriesAfterBooking",
  initialState,
  reducers: {
    clearError(state) {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCategoriesAfterBookingThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCategoriesAfterBookingThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.categories = action.payload;
      })
      .addCase(fetchCategoriesAfterBookingThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

// Export actions and reducer
export const { clearError } = categoriesAfterBookingSlice.actions;
export default categoriesAfterBookingSlice.reducer;
